import React, { useState } from "react"
import { useFlexSearch } from "react-use-flexsearch"
import { graphql, useStaticQuery } from "gatsby"
import SearchBar from "../components/searchBar"
import CardsGallery from "./CardsGallery"
import distinct from "../helper/distinct"

const reverseName = s => {
  const name = s.split(" ")
  const lastName = name.pop()
  return lastName + ", " + name.join(" ")
}

const SearchEngine = () => {
  const data = useStaticQuery(graphql`
    query {
      allVideosJson {
        edges {
          node {
            id
            slug
            tags
            title
            speaks {
              speaker
              title
            }
          }
        }
      }
      localSearchSessions {
        index
        store
      }
    }
  `)

  const [searchQuery, setSearchQuery] = useState("")

  const videoIds = data.allVideosJson.edges.map(e => e.node.id)
  const results = useFlexSearch(
    searchQuery,
    data.localSearchSessions.index,
    data.localSearchSessions.store
  )

  const matches = results.map(res => res.id)

  const sessionIds = searchQuery === "" ? videoIds : matches

  const allSpeakers = ["Speaker"].concat(
    data.allVideosJson.edges
      .map(e => e.node.speaks.map(s => s.speaker))
      .flat()
      .filter(distinct)
      .map(s => reverseName(s))
      .sort()
  )

  return (
    <div id="sessions" className="justify-center">
      <div className="m-auto">
        <div className="container md:max-w-4xl m-auto">
          <SearchBar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            allSpeakers={allSpeakers}
          />
        </div>
      </div>
      <CardsGallery sessionIds={sessionIds} />
    </div>
  )
}

export default SearchEngine
